export const failure = (type) => `${type}_FAIL`;
export const success = (type) => `${type}_SUCCESS`;
